import { useSelector } from 'react-redux';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultProcessAreaResource,
    ProcessAreaMutationResourceSchema,
    useProcessAreaActions,
} from '../../../../../resource/resources/artifacts/process_area/processAreaResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { ProcessAreaContent } from './ProcessAreaContent';

export const ProcessAreaEditDialog = ({
    onClose,
    objectId,
    versionedInId,
}: {
    onClose: () => void;
    objectId: string | undefined | null;
    versionedInId: string;
}) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const processAreaActions = useProcessAreaActions();
    const processAreaQuery = processAreaActions.useGetResourceByObjectIdAndVersionedIn(objectId, versionedInId);
    const updateProcessArea = processAreaActions.useUpdateResource();
    const validation = processAreaActions.useValidateResource(processAreaQuery.data?.id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: ProcessAreaMutationResourceSchema,
        defaultValues: defaultProcessAreaResource,
        submitHandler: async (data) => {
            await updateProcessArea.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: processAreaQuery.data,
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Edit Process Area'}
            resourceType={ResourceType.PROCESS_AREA}
            resourceValidationResult={validation.data}
            metaDataInfo={processAreaQuery.data}
        >
            <QueryBaseComponent name="ProcessArea" query={processAreaQuery}>
                <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                    <ProcessAreaContent
                        form={form}
                        formNames={formNames}
                        readOnly={readOnly}
                        id={processAreaQuery.data?.id}
                    />
                </Form_DisplayComponentBaseView>
            </QueryBaseComponent>
        </EditChildBaseDialog>
    );
};
